import header from "../components/header";
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  FormControlLabel,
  Checkbox,
  Button
} from '@mui/material';

const TermsAgreement = ({ onAgree }) => {
  const [agreed, setAgreed] = useState(false);

  const content = `أولاً:- يتم تقديم إستمارة الكترونية واحدة فقط للجريح (من قبل الجريح نفسه) وإستمارة واحدة فقط للشهيد تقدم من قبل أحد ذوية وكما يأتي:
الشهيد الأعزب: تقدم الاستمارة من قبل أحد الوالدين أو أحد الاخوة أو الأخوات 
الشهيد المتزوج : تقدم الاستمارة من من قبل زوجتة أو أحد أولاده.
الشهيد متزوج بأكثر من زوجه: تقدم إستمارة واحدة من قبل كل زوجه وأولادها(يكون عدد الاستمارات حسب عدد الزوجات) مع مراعاة ذكر أسماء جميع الزوجات عند ملء الاستمارة في الحقول المخصصة لهذا الغرض .

ثانياً:  يجب أرفاق صور ضوئية واضحة من بطاقة السكن والبطاقة الوطنية (وجهين) للجريح وكذلك نفس المستمسكات لكافة ذوي الشهداء (المستفيدين المشمولين بقانون رقم 20 لسنة 2009 المعدل).

ثالثاً:-  يكون ملء استمارة جمع البيانات لكافة الشهداء والجرحى المشمولين بقانون رقم (20) لسنة 2009 المعدل خلال (30) يوما من تاريخ إطلاق الاستمارة وبعدها يتم غلق الاستمارة الالكترونية.

رابعاً:- يجب ابلاغ المديرية الموثق فيها الشهيد أو الجريح في حالة وجود قرارات مزدوجة للشهيد الموظف (المدني أو العسكري) أي عند وجود قرارين  أحدهما صادر من اللجان الفرعية في المحافظات باعتباره (كاسب) وقرار آخر صادر من الوزارة التي كان يعمل فيها الشهيد أو الجريح لغرض معالجة ذلك وفي حالة عدم الإبلاغ يتم إيقاف مستحقات الشهيد واتخاذ الإجراءات القانونية بحق مقدم الاستمارة.

خامساً:- قرار الشهيد أو الجريح الذي سيصدر بعد إطلاق هذه الاستمارة فأن الجهة التي يصدر عنها القرار (اللجنة الفرعية في المحافظات أو اللجان الثلاثية في الوزارات) هي المسؤولة عن ملء هذه الاستمارة بموجب المعلومات المتوفرة لديهم من خلال الاضبارة المنظورة أمام اللجنة .
`;

  return React.createElement(
    Box,
    {
      p: 4,
      component: Paper,
      sx: {
        direction: 'rtl',
        maxHeight: '80vh',
        overflowY: 'auto',
        whiteSpace: 'pre-line',
        textAlign: 'center',
        fontSize: '1rem',
        lineHeight: 2
      }
    },
    [
      React.createElement(header, { key: "header" }),
      React.createElement(
        Typography,
        {
          variant: "h6",
          gutterBottom: true,
          color: "primary",
          key: "title"
        },
        "يرجى قراءة الضوابط والالية بشكل كامل قبل المتابعة"
      ),
      React.createElement(
        Typography,
        {
          variant: "body1",
          key: "content",
          style: { marginBottom: '16px', whiteSpace: 'pre-line' }
        },
        content
      ),
      React.createElement(
        FormControlLabel,
        {
          key: "checkbox",
          control: React.createElement(Checkbox, {
            checked: agreed,
            onChange: (e) => setAgreed(e.target.checked),
            color: "primary"
          }),
          label: "لقد اطلعت على الشروط والضوابط واتحمل مسؤولية المعلومات المدخلة في النظام"
        }
      ),
      React.createElement(
        Box,
        { mt: 2, key: "buttonBox" },
        React.createElement(Button, {
          variant: "contained",
          color: "primary",
          disabled: !agreed,
          onClick: onAgree
        }, "موافق ومتابعة")
      )
    ]
  );
};

export default TermsAgreement;
